import moment from 'moment'
import {orderBy} from 'lodash'
import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import {makeStyles, useTheme, useMediaQuery} from 'external/material'
import {createPost} from 'helpers/command'
import SelectStudents from './SelectStudents'
import InfoBar from './InfoBar'
import AssignmentInfo from './AssignmentInfo'

const initialState = {
  students: [],
  selectedStudents: [],
  checkedStudents: {},
}

const useStyles = makeStyles(editStudentAssignmentStyles)
const useDialogStyles = makeStyles(dialogStyles)

export default function EditStudentAssignment ({context}) {

  const theme = useTheme()
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const {translate, updateState, quizAssignmentToModify: assignment, quizDialogs} = context

  const classes = useStyles()
  const dialogClasses = useDialogStyles()
  const [state, setState] = React.useState(initialState)

  const isOpen = quizDialogs['edit-student-assignment'] !== false && assignment.id != undefined


  function handleStudentsChecked(id, value) {
    setState({...state, checkedStudents: {...state.checkedStudents, [id]: value}})
  }

  function handleStudentsChange({left, right}) {
    setState({...state, students: left, selectedStudents: right})
  }

  async function handleSave() {
    const {id} = assignment
    const students = state.selectedStudents.map(s => s.id)
    await createPost('quiz', 'updateStudentAssignment')({id, students})
    await context.updateState({quizAssignmentCalls: {$apply: c => c + 1}})
    close()
  }

  async function close () {
    await context.updateState({quizDialogs: {['edit-student-assignment']: {$set: false}}})
  }

  const expired = moment().isAfter(assignment.finish)

  React.useEffect(() => {
    if (assignment.id != undefined) {
      const {group} = assignment
      const {students: groupStudents = []} = context.groups.find(g => g.id == group) || {}
      const students = groupStudents.filter(s => assignment.students.indexOf(s.id) < 0)
      const selectedStudents = groupStudents
        .filter(s => assignment.students.indexOf(s.id) > -1)
        .map(s => ({...s, readOnly: expired || assignment.started.indexOf(s.studentId) >= 0}))
      const checkedStudents = groupStudents.reduce((acc, s) => {
        acc[s.id] = false
        return acc
      }, {})
      setState({...state, students: orderBy(students, ['name']), checkedStudents, selectedStudents: orderBy(selectedStudents, ['readOnly', 'name'], ['desc','asc'])})
    }
  }, [assignment])

  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={e => close(e)}
      classes={dialogClasses}
      aria-labelledby="edit-student-assignment-responsive-dialog-title"
      maxWidth="lg"
    >
      <DialogTitle
        id="edit-student-assignment-responsive-dialog-title"
        className={classes.title}
      >
        <InfoBar context={context} />
      </DialogTitle>
      <DialogContent className={classes.content}>
        <Box className={classes.info}>
          <AssignmentInfo context={context} />
        </Box>
        <Box className={classes.students}>
          <SelectStudents
              expired={expired}
              students={state.students}
              selectedStudents={state.selectedStudents}
              checkedStudents={state.checkedStudents}
              onStudentsChecked={handleStudentsChecked}
              onStudentsChange={handleStudentsChange}
              context={context} 
          />
        </Box>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Button
          variant={"outlined"}
          className={clsx(classes.button, "cancel")}
          color="secondary"
          onClick={close}>
          {translate(expired ? 'close' : 'cancel')}
        </Button>
        {!expired && (
        <Button
          variant="contained"
          color="primary"
          className={clsx(classes.button, "save")}
          onClick={handleSave}>
            {translate('save')}
        </Button>)}
      </DialogActions>
    </Dialog>
  )
}

function dialogStyles(theme) {
  return {
    paper: {
      width: '100%',
      padding: 0,
      height: 'calc(100% - 100px)'
    }
  }
}

function editStudentAssignmentStyles(theme) {
  return {
    root: {
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 24px 0 24px'
    },
    students: {
      display: 'flex',
      marginTop: 20,
      flexGrow: 1
    },
    title: {
      padding: 0
    },
    actions: {
      padding: '20px 24px'
    },
    button: {
      textTransform: 'none',
      "&.cancel": {
        color: '#3d4556',
        border: 'solid 1px #3d4556'
      }
    }
  }
}
